const commons = {
    TRANSACTIONACOUNT: 'transactionaccount',
    CONTINGENT: 'contingent',
    ACCOUNT: 'account',
    NOTIFICATIONS: 'notifications',
    TOKEN: 'token',
};

export default commons
